var _rect, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPancakeSwap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "url(#paint0_linear_10011_6268)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76 58C76 67.8 61 76.5 45 76.5C29 76.5 15.5 67.4 15.5 57.6L16.7996 53H74.9996L76.5 57.6L76 58Z",
    fill: "#FEDC90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 22.3991C26.2 18.7991 29.9 15.5 33.5 15.5C36.7 15.5 40.5 19.1991 40.5 22.3991V34.5C42.5 34.3 43.5996 34.5 45.7996 34.5C47.7996 34.5 48.5 34.3 50.5 34.5V22.3991C50.5 19.1991 54.3 15.5 57.5 15.5C61.1 15.5 64.6 19.9991 64 23.5991L62.5 37.9991C70.9 41.1991 75 46.7991 75 53.1991C75 62.9991 61.7996 70.9991 45.7996 70.9991C29.7996 70.9991 16 62.9991 16 53.1991C16 46.7991 21.6 41.1991 30 37.9991L27 22.3991Z",
    fill: "#D1884F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6002 51.8C37.6002 54.4 36.2002 56.6 34.4002 56.6C32.6002 56.6 31.2002 54.4 31.2002 51.8C31.2002 49.2 32.6002 47 34.4002 47C36.2002 47 37.6002 49.2 37.6002 51.8Z",
    fill: "#633001"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8009 51.8C59.8009 54.4 58.4009 56.6 56.6009 56.6C54.8009 56.6 53.4009 54.4 53.4009 51.8C53.4009 49.2 54.8009 47 56.6009 47C58.4009 47 59.8009 49.2 59.8009 51.8Z",
    fill: "#633001"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.4 24C24.4 18.8 28.4 14 33.6 14C38.2 14 42 17.8 42 22.4V32.8C43.2 32.8 44.4 32.6 45.6 32.6C46.8 32.6 47.8 32.6 49 32.8V22.4C49 17.8 52.8 14 57.4 14C62.6 14 66.6 18.8 65.8 24L63.6 36.2C71.4 39.6 77.4 45.6 77.4 53V57.6C77.4 63.8 73.4 69 67.6 72.4C61.8 76 54.2 78 45.6 78C37 78 29.4 76 23.6 72.4C18 69 14 63.8 14 57.6V53C14 45.6 19.8 39.6 27.6 36.2L25.4 24ZM60.6 37.8L63.2 23.4C63.8 19.8 61.2 16.4 57.4 16.4C54.2 16.4 51.6 19 51.6 22.2V35.4C50.8 35.2 49.8 35.2 49 35.2C47.8 35.2 46.8 35 45.6 35C44.4 35 43.2 35 42 35.2C41.2 35.2 40.2 35.4 39.4 35.4V22.4C39.4 19.2 36.8 16.6 33.6 16.6C30 16.6 27.2 20 28 23.6L30.6 38C22.2 41.2 16.6 46.8 16.6 53.2V57.8C16.6 67.6 29.6 75.6 45.6 75.6C61.6 75.6 74.6 67.6 74.6 57.8V53.2C74.8 46.6 69.2 41 60.6 37.8Z",
    fill: "#633001"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10011_6268",
    x1: 46,
    y1: 0,
    x2: 46,
    y2: 92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51DDE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21C8D5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPancakeSwap);
export default __webpack_public_path__ + "static/media/PancakeSwap.1947692e21155bb180a951c9ceca08eb.svg";
export { ForwardRef as ReactComponent };